import Vue from 'vue';
import Router from 'vue-router';

import store from '../store';
import routers from './routers';
import Api from '../api';

import * as types from '../store/types';
import * as LS from '../utils/storage';
import { getUrlQueryParams, isWexin } from '../utils/util';

Vue.use(Router);
const appEnv = require('../../config/app.env');

const router = new Router({
  base: appEnv.BASE_SPLIT,
  // mode: 'history',
  routes: routers,
  scrollBehavior: () => ({ y: 0 }),
});

if (!isWexin()) {
  window.location.href = `${window.location.origin}${appEnv.BASE_SPLIT}#/weixin`;
}

router.beforeEach((to, from, next) => {
  let wxUser = LS.getItem('wxuser');
  if (!wxUser || !wxUser.openId) {
    const param = getUrlQueryParams(window.location.href);
    if (param.code && param.code.length > 0) {
      Api.login.getWxUserInfo({
        code: param.code,
      }).then((res) => {
        const wx = {
          openId: res.openId,
          nickname: res.nickname,
          sex: res.sex,
          headImgUrl: res.headImgUrl,
        };
        store.commit(types.AUTH_SET_WXUSER, wx);
        wxUser = wx;
        const visitUrl = LS.getItem('visitUrl') || '/';
        LS.setItem('visitUrl', '');
        window.location.href = `${window.location.origin}${appEnv.BASE_SPLIT}#${visitUrl}`;
      });
    } else {
      LS.setItem('visitUrl', to.fullPath);
      Api.login.getAuthUrl({
        redirectUrl: window.location.href,
      }).then((res) => {
        window.location.href = res;
      });
    }
  }

  if (wxUser && wxUser.openId) {
    if (to.matched.some(record => record.meta.requireAuth)) {
      if (store.getters.accessToken) {
        next();
      } else {
        const authUser = LS.getItem('wxuser');
        if (authUser && authUser.openId) {
          Api.login.weChatLogin(authUser.openId).then((r) => {
            store.commit(types.AUTH_LOGIN, {
              accessToken: r.token,
              refreshToken: r.refreshToken,
            });
            next();
          });
        }
      }
    } else if (store.getters.accessToken && to.fullPath === '/binding') {
      next('/');
    } else {
      next();
    }
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js